import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  private userMenuDetailsSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public userMenuDetails$: Observable<any> = this.userMenuDetailsSubject.asObservable();

  constructor() {
    const storedMenu = this.getLocalStorageItem("userMenuDetails");
    if (storedMenu) {
      this.userMenuDetailsSubject.next(storedMenu);
    }
  }

  private encode(value: any): string {
    try {
      return btoa(unescape(encodeURIComponent(JSON.stringify(value))));
    } catch (e) {
      console.error("[LocalStorageService] Encode error:", e);
      return JSON.stringify(value);
    }
  }

  private decode(raw: string): any {
    try {
      // attempt base64 decode
      return JSON.parse(decodeURIComponent(escape(atob(raw))));
    } catch {
      try {
        // fallback for legacy plain-JSON values written before encryption
        return JSON.parse(raw);
      } catch {
        // value is corrupted or tampered — clear session and force re-login
        this.handleCorruptedStorage();
        return null;
      }
    }
  }

  private handleCorruptedStorage(): void {
    localStorage.clear();
    window.location.href = "/login";
  }

  setLocalStorageItem(key: string, value: any): void {
    localStorage.setItem(key, this.encode(value));
    if (key === "userMenuDetails") {
      this.userMenuDetailsSubject.next(value);
    }
  }

  getLocalStorageItem(key: string): any {
    const raw = localStorage.getItem(key);
    if (raw === null) return null;
    return this.decode(raw);
  }

  removeLocalStorageItem(key: string): void {
    localStorage.removeItem(key);
    if (key === "userMenuDetails") {
      this.userMenuDetailsSubject.next(null);
    }
  }

  clearLocalStorage(): void {
    localStorage.clear();
  }

  getFlexYearToken(): string {
    return this.getLocalStorageItem("flexYear-token");
  }
}